<template>
  <!-- 已弃用 -->
  <div class="certificate-box">
    <div
      class="card-box"
      v-for="group in imageList"
      :key="group.primaryCode"
    >
      <div class="card-title">
        {{ group.primaryName }}
      </div>
      <div class="card-content">
        <template
          v-for="(item, index) in group.secondary"
        >
          <div
            class="img-box"
            :key="index"
          >
            <div class="img-title">
              <span>{{ item.typeName }}</span>
              <span
                class="color-red"
                v-if="item.requiredNum === 1"
              >(必传)</span>
            </div>
            <div
              class="img-content"
              v-if="item.mediaList"
            >
              <div class="img-upload">
                <van-uploader
                  v-model="item.mediaList"
                  accept=".jpg, .png, .jpeg, .mp3, .mp4, .m4a, .JPG, .PNG, .JPEG, .MP3, .MP4, .M4A"
                  :max-count="item.maxNum"
                  :before-read="beforeRead"
                  :after-read="({file}) => {afterRead(file, item)}"
                  :before-delete="beforeDelete"
                  @delete="delMediaById"
                >
                  <div
                    class="img-upload-btn"
                    :style="{'background-image': `url(${item.backgroundUrl})`}"
                  />
                </van-uploader>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- 确认弹窗 -->
    <ConfirmDialog
      ref="confirmDialog"
    />
    <!-- 图片处理弹窗 -->
    <ImageCropper
      ref="imageCropper"
    />
  </div>
</template>

<script>
import {
  mediaTemplate,
  getMediaDetail,
  saveMedia,
  delMediaById
} from '@/common/apiGeneral.js';
import {
  getTaskDetail
} from '@/common/apiPaic.js';
import { upload, getFileName } from '@/utils/ourOss';
import ConfirmDialog from '@/components/confirmDialog.vue';
import ImageCropper from '../components/imageCropper.vue';
import Compressor from 'compressorjs';
import { handleBrowserGoBack, pushHistory, removeBrowserBackListener } from '../common/utils';
import MobileDetect from 'mobile-detect';
import { judgeBrand, arrModal } from '../common/mobileInfo';
import dayjs from 'dayjs';
import getCurrentPositionMixin from '../mixins/getCurrentPositionMixin';
import { cloneDeep } from 'lodash';
export default {
  name: 'GeneralOrderCertificate',
  mixins: [getCurrentPositionMixin],
  components: {
    ConfirmDialog,
    ImageCropper
  },
  data() {
    return {
      orderNo: '',
      taskNo: '',
      useTraceCar: '',
      pictureTypes: [],
      imageList: [],
      unCompletedTxt: [],
      taskDetail: {}
    };
  },
  created() {
    const {
      photoParams
    } = this.$route.query;
    if (photoParams) {
      const {
        orderNo,
        taskNo,
        useTraceCar,
        pictureTypes
      } = JSON.parse(photoParams);
      this.orderNo = orderNo;
      this.taskNo = taskNo;
      this.useTraceCar = useTraceCar;
      this.pictureTypes = pictureTypes;
      this.getTaskDetail();
      this.mediaTemplate();
    }
  },
  mounted() {
    console.log(window.screen.width);
    // 设置返回监听
    handleBrowserGoBack(this.back);
  },
  destroyed() {
    removeBrowserBackListener(this.back);
  },
  methods: {
    getMobileName() {
      // const userAgent = 'Mozilla/5.0 (Linux; Android 12; HarmonyOS; ABR-AL00; HMSCore 6.9.6.302) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/99.0.4844.88 HuaweiBrowser/13.0.4.302 Mobile Safari/537.36';
      // const userAgent = 'Mozilla/5.0 (Linux; U; Android 10; zh-cn; M2002J9E Build/QKQ1.191222.002) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/100.0.4896.127 Mobile Safari/537.36 XiaoMi/MiuiBrowser/17.5.120328 swan-mibrowser';
      // const userAgent = 'Mozilla/5.0 (Linux; Android 13; M2012K11AC Build/TKQ1.220829.002; ) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/104.0.5112.97 Mobile Safari/537.36 BingSapphire/23.8.2110003536';
      const userAgent = window.navigator.userAgent;
      console.log(userAgent, '获取userAgent信息');

      const md = new MobileDetect(userAgent);
      let os = md.os(); // 获取系统
      let model = md.mobile();
      let val;
      if (os === 'iOS') {
        // ios系统的处理
        // console.log(md.mobile(), os, '获取系统', os === 'iOS');
        if (model === 'iPhone') {
          const iphoneArr = [
            ['430,932,3', 'A15', 'iPhone 14 Pro Max'],
            ['393,852,3', 'A15', 'iPhone 14 Pro'],
            ['375,812,3', 'A15', 'iPhone 13(12) min'],
            ['428,926,3', 'A14', 'iPhone 14(12/13) Plus'],
            ['390,844,3', 'A14', 'iPhone 14(12/13)'],
            ['414,896,3', 'A13', 'iPhone 11 Pro Max(Xs Max)'],
            ['375,812,3', 'A13', 'iPhone 11 Pro(X/Xs)'],
            ['414,896,2', 'A13', 'iPhone 11(XR)'],
            ['414,736,3', 'A12', 'iPhone 8(7/6s) Plus'],
            ['375,667,2', 'A11', 'iPhone 8(7/6)'],
            ['320,568,2', 'A11', 'iPhone 5(s/se)'],
            ['320,480,2', 'A10', 'iPhone 4(s)']
          ];

          // 获取GPU信息
          const canvas = document.createElement('canvas');
          const gl = canvas.getContext('experimental-webgl');
          const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');

          const iphoneGPU = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
          const width = window.screen.width;
          const height = window.screen.height;
          const devicePixelRatio = window.devicePixelRatio;
          console.log(width, height, devicePixelRatio);

          const baseInfo = width + ',' + height + ',' + devicePixelRatio;
          iphoneArr.some((item) => {
            if (item[0] === baseInfo) {
              model = item[2];
              console.log('iphoneGPU', iphoneGPU === item[1]);
            }
          });
          os = +md.version('iPhone');
          // console.log(`${md.mobile()} IOS${os}`);
          // console.log(model, '鸡鸡', userAgent.toLowerCase());
          val = model;
        } else {
          model = 'iPad';
        }
      } else if (os === 'AndroidOS') {
        // Android系统的处理
        if (!model || model === 'UnknownPhone' || model === 'UnknownMobile') {
          let j;
          const sss = userAgent.split(';');
          for (let i = 0; i < sss.length; i++) {
            if (sss[i].indexOf('Build/') > 0) {
              j = i;
              break;
            }
          }
          if (j > -1) {
            model = sss[j].substring(0, sss[j].indexOf('Build/'));
            val = model;
          } else {
            if (!val) {
              // 处理华为
              if (userAgent.split(')')[0].includes('HMSCore')) {
                const HMS = userAgent.split(')')[0].split('HMSCore')[0].split(';');
                model = HMS[HMS.length - 2];
                val = 'Huawei' + model;
              }
            }
          }

          arrModal.map((item) => {
            if (item.type === judgeBrand(userAgent.toLowerCase())) {
              item.modelNumber.map((vm) => {
                if (vm.lable === model.trim()) {
                  val = vm.value;
                }
              });
            }
          });
        } else {
          val = model;
        }
      }

      // console.log(val);
      val = val || '其他型号手机';
      console.log('我model是', val);
      return val;
    },
    back() {
      console.log(this.unCompletedTxt);
      if (this.unCompletedTxt.length) {
        const confirmText = `根据业务要求，你还缺${this.unCompletedTxt.join('、')}未拍，确定离开当前页面不继续拍照了吗？`;
        this.$refs.confirmDialog.open({
          confirmText,
          confirmButtonText: '继续拍照',
          cancelButtonText: '暂时离开',
          confirmCallback: () => {
            pushHistory(this.back);
          },
          cancelCallback: () => {
            this.$router.go(-1);
          }
        });
      } else {
        this.$router.go(-1);
      }
    },
    async getTaskDetail(noLoading) {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async mediaTemplate(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await mediaTemplate({
          orderNo: this.orderNo,
          useTraceCar: this.useTraceCar,
          pictureTypes: this.pictureTypes,
          requestType: this.pictureTypes.length ? 2 : 1
        });
        if (data) {
          this.imageList = data;
          this.getMediaDetail();
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMediaDetail(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getMediaDetail({
          orderNo: this.orderNo
        });
        console.log(data);
        if (data) {
          this.unCompletedTxt = [];
          this.imageList.forEach(group => {
            group.secondary.forEach(item => {
              const mediaList = data.filter(media => {
                if (media.categoryCode === item.categoryCode) {
                  media.isImage = media.fileType === 'image';
                  return media;
                }
              });
              if (!(mediaList && mediaList.length) && item.requiredNum === 1) {
                this.unCompletedTxt.push(item.typeName);
              }
              this.$set(item, 'mediaList', mediaList);
            });
          });
          console.log('this.imageList: ', this.imageList);
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async beforeRead(file) {
      return new Promise((resolve, reject) => {
        // 设置允许上传图片格式为jpg
        const FileExt = file.name.replace(/.+\./, '');
        const isLtFileType = ['jpg', 'png', 'jpeg', 'mp3', 'mp4', 'm4a'].includes(FileExt.toLowerCase());
        if (!isLtFileType) {
          this.$toast('上传文件只能是jpg, png, jpeg, mp3, mp4, m4a格式');
          reject();
          return false;
        }
        const isLtFileSize = file.size / 1024 / 1024 < 10;

        if (!isLtFileSize) {
          this.$toast('上传文件大小不能超过 10MB!');
          reject();
          return false;
        }

        const isLtFileName = getFileName(file.name).length <= 50;
        // 限制文件名
        if (!isLtFileName) {
          this.$toast('文件名不能超过50个字符');
          reject();
          return false;
        }
        resolve(file);
      });
    },
    doCompressor(file, dayjsDate) {
      return new Promise((resolve, reject) => {
        // 将图片压缩到1M以内
        const quality = 0.9;
        const compressor = new Compressor(file, {
          quality,
          maxWidth: 1080,
          maxHeight: window.screen.height,
          drew: (context, canvas) => {
            const wordLength = 30;
            const fontBit = canvas.width / wordLength;
            console.log('fontBit: ', fontBit);
            context.font = fontBit + 'px Vedana';
            context.fillStyle = '#F32222';
            context.textAlign = 'right';
            context.textBaseline = 'Middle';
            context.fillText(`救援师傅:${this.taskDetail.workerName}`, canvas.width, fontBit); // 水印在画布的位置x，y轴
            context.fillText(`(${this.getMobileName()}相机)${dayjsDate.format('YYYY-MM-DD HH:mm:ss')}`, canvas.width, fontBit * 2);
            // 计算地址的长度，超过一屏就换行
            const addressWordLength = this.currentPosition.formattedAddress.length;
            const lines = Math.ceil(addressWordLength / wordLength);
            if (lines > 1) {
              for (let index = 0; index < lines; index++) {
                const address = this.currentPosition.formattedAddress.slice(wordLength * index, wordLength * (index + 1));
                context.fillText(address, canvas.width, fontBit * (3 + index));
              }
            } else {
              context.fillText(this.currentPosition.formattedAddress, canvas.width, fontBit * 3);
            }
            context.fillText(`经度:${this.currentPosition.longitude} 纬度:${this.currentPosition.latitude}`, canvas.width, fontBit * (3 + lines));
          },
          success: (result) => {
            resolve(result);
          },
          error(err) {
            console.log(err.message);
          }
        });
        console.log(compressor);
      });
    },
    // 自定义上传
    async afterRead(file, { categoryCode, isWorkingSpacePic }) {
      console.log(file.name, 'afterRead file.name');
      console.log(file, 'afterRead file');
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      let realFile = cloneDeep(file);
      let virtualFile = cloneDeep(file);
      let realPicFileId = '';
      let waterMarkTime = '';
      let resArr = [];
      // compressorjs 默认开启 checkOrientation 选项
      // 会将图片修正为正确方向
      if (file.type.includes('image')) {
        realFile = await this.doCompressor(file, dayjs());
        if (isWorkingSpacePic) {
          // 大于5分钟将生成两张图片
          const today = dayjs();
          const arriveTime = dayjs(this.taskDetail.latestArriveTime);
          console.log('today: ', today.unix());
          console.log('arriveTime: ', arriveTime.unix());
          const diff = today.diff(arriveTime, 'minute', true);
          console.log('diff: ', diff);

          const orderCreateTime = dayjs(this.taskDetail.orderCreateTime);
          const diff2 = today.diff(orderCreateTime, 'minute', true);

          // 到达时间大于5分钟将生成两张图片 && 非预约单 && 下单时间未超过1小时
          if (diff > 5 && diff2 <= 60 && this.taskDetail.appointmentTime !== '实时订单') {
            // 获取缓存的虚拟时间
            const localWaterMarkTime = localStorage.getItem('ORDER_GENERAL_certificate_waterMarkTime-' + this.taskDetail.taskNo);
            if (localWaterMarkTime) {
              // 5-15s
              const randomTime = Math.random() * 10 + 5;
              waterMarkTime = 1 * localWaterMarkTime + 1 * randomTime;
            } else {
              // 取1分钟至5.5分钟内随机数
              const randomTime = Math.random() * 4.5 * 60 + 60;
              waterMarkTime = 1 * arriveTime.unix() + 1 * randomTime;
            }
            // 压缩
            virtualFile = await this.doCompressor(file, dayjs.unix(waterMarkTime));
            console.log('waterMarkTime: ', waterMarkTime);
            console.log('realFile: ', realFile);
            console.log('virtualFile: ', virtualFile);
            // return;
            resArr = await Promise.all([upload(realFile), upload(virtualFile)]);
            const isSuccess = resArr.every(res => (String(res.data.code) === '0'));
            if (!isSuccess) {
              this.$toast('上传失败');
              return;
            } else {
              const res = resArr[0];
              const data = res.data.data;
              realPicFileId = data.picId;
              // 缓存虚拟时间
              localStorage.setItem('ORDER_GENERAL_certificate_waterMarkTime-' + this.taskDetail.taskNo, waterMarkTime);
            }
          } else {
            const res = await upload(realFile);
            if (!(String(res.data.code) === '0')) {
              this.$toast(res.data.message);
              return;
            }
            resArr = [res];
          }
        } else {
          const res = await upload(realFile);
          if (!(String(res.data.code) === '0')) {
            this.$toast(res.data.message);
            return;
          }
          resArr = [res];
        }
      } else {
        const res = await upload(file);
        if (!(String(res.data.code) === '0')) {
          this.$toast(res.data.message);
          return;
        }
        resArr = [res];
      }

      const medias = resArr.map((res, index) => {
        const data = res.data.data;
        let fileType = 'image';
        const arr = file.name.split('.');
        const suffix = arr[arr.length - 1].toLowerCase();
        if (['mp4'].includes(suffix)) {
          fileType = 'video';
        }
        if (['mp3', 'm4a'].includes(suffix)) {
          fileType = 'audio';
        }
        let media = {

          'categoryCode': categoryCode,
          'fileName': file.name,
          'fileType': fileType,
          'orderNo': this.orderNo,
          'uploadFrom': 'H5上传',
          'fileId': res.type === 'myFile' ? data.fileId : data.picId
        };
        if (index === 1) {
          media = {
            ...media,
            'realPicFileId': realPicFileId,
            'virtualMarkTime': dayjs.unix(waterMarkTime).format('YYYY-MM-DD HH:mm:ss')
          };
        }
        return media;
      });

      console.log('medias: ', medias);

      const uploadParams = {
        medias
      };
      try {
        await saveMedia(uploadParams);
        this.$toast('上传成功');
        this.getMediaDetail();
      } catch (error) {
        console.log(error);
      }
      this.$toast.clear();
    },
    // 自定义上传
    async beforeDelete(file) {
      return new Promise((resolve, reject) => {
        const confirmText = '确定删除该图片吗?';
        this.$refs.confirmDialog.open({
          confirmText,
          confirmCallback: () => {
            console.log('confirmCallback');
            resolve(file);
          },
          cancelCallback: () => {
            reject();
          }
        });
      });
    },
    async delMediaById(file, detail, noLoading) {
      console.log('delMediaById: ', { file, noLoading });
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        await delMediaById({
          orderNo: this.orderNo,
          mediaId: file.id
        });
        this.getMediaDetail();
        if (!noLoading) {
          this.$toast.clear();
        }
        this.$toast('删除成功');
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.certificate-box{
  overflow-y: auto;

  height: calc(100vh - 46px);

  background: #F2F3F5;

  .card-box{
    margin: 12px;

    border-radius: 8px;
    background: #FFFFFF;

    & + .card-box{
      margin-top: 0;
    }

    .card-title{
      position: relative;

      padding: 12px 16px 12px 25px;

      letter-spacing: 0;

      color: #383838;
      // border-bottom: 1px solid #E6E6E6;

      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 500;
      &::before{
        position: absolute;
        left: 16px;

        width: 4px;
        height: 15px;

        content: ' ';

        background: #D1D1D1;
      }
      &::after{
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;

        width: 100%;
        height: 1px;

        content: ' ';
        transform: scaleY(0.5);

        background: #E6E6E6;
      }
    }

    .card-content{
      padding: 10px 16px 16px;
      .img-box{
        & + .img-box{
          margin-top: 24px;
        }
        .img-title{
          color: #383838;

          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: 400;

          .color-red{
            color: #FF8A59;
          }
        }
        .img-content{
          display: flex;
          align-items: flex-end;

          .img-upload{
            margin-top: 10px;

            .img-upload-btn{
              position: relative;

              display: -webkit-box;
              display: -webkit-flex;
              display: flex;
              align-items: center;
              flex-direction: column;
              justify-content: center;

              box-sizing: border-box;
              width: 80px;
              height: 80px;
              margin: 0 8px 8px 0;

              background-color: #f7f8fa;
              background-repeat:no-repeat;
              background-position: center center;
              background-size: auto 100%;

              .van-icon {
                color: #dcdee0;

                font-size: 24px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
